import { Flex, Paper, Text, ThemeIcon } from '@mantine/core';
import { IconListSearch } from '@tabler/icons-react';

import type { CandidatePickVacancyMeta } from '../../types';

import { CandidatePickVacancyRow } from './CandidatePickVacancyRow';

export const CandidatePickEmptyState = ({
  vacancyTitle,
  vacantPlaces,
}: CandidatePickVacancyMeta) => {
  return (
    <Flex direction='column' gap={24} flex={1} miw={0} mih={0} w='100%'>
      <CandidatePickVacancyRow
        vacancyTitle={vacancyTitle}
        vacantPlaces={vacantPlaces}
      />

      <Paper
        bg='primary.0'
        radius={16}
        bd='1px solid transparent'
        mih={0}
        w='100%'
      >
        <Flex
          direction='column'
          align='center'
          justify='center'
          gap={24}
          px={32}
          py={72}
        >
          <ThemeIcon size={72} radius='50%' bg='white' c='tertiary.7'>
            <IconListSearch size={32} stroke={1.5} />
          </ThemeIcon>
          <Flex direction='column' align='center' gap={16} ta='center'>
            <Text size='md' fw={600} c='tertiary.7'>
              Релевантных кандидатов не найдено
            </Text>
            <Text size='sm' c='tertiary.7'>
              Попробуйте выполнить поиск позже
            </Text>
          </Flex>
        </Flex>
      </Paper>
    </Flex>
  );
};
